import * as React from 'react';
import { useCallback } from 'react';

import { Icon } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { ActionButtonVariants } from 'components/action-button';
import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';
import { routes } from 'utils/routing';
import { isDelivery, isPickup } from 'utils/service-mode';

import { ActionButtonStyled } from '../styled';
import { ICTAButtonProps, ICTAButtonsProps } from '../types';

const CTAButton = ({
  children,
  iconVariant,
  primary,
  defaultLinkTo,
  isMatchingServiceMode,
  numberOfItemsInCart,
  navigate,
  marginTop,
  eventName,
  itemId,
  backgroundColor,
  _text,
}: ICTAButtonProps) => {
  const shouldGoToCart = isMatchingServiceMode && numberOfItemsInCart > 0;
  const { formatMessage } = useIntl();
  const { logEvent } = useMParticleContext();

  const handleOnPress = useCallback(() => {
    let path: string = defaultLinkTo;
    path = isMatchingServiceMode ? '/menu' : path;
    path = shouldGoToCart ? '/cart' : path;

    logEvent(eventName, EventTypes.Navigation, {
      'Hero URL': path,
      'Hero ID': itemId,
    });

    return navigate(path);
  }, [defaultLinkTo, eventName, isMatchingServiceMode, itemId, logEvent, navigate, shouldGoToCart]);

  const continueToCartText = shouldGoToCart
    ? formatMessage({ id: 'continueToCart' }, { numberOfItemsInCart })
    : children;

  return (
    <ActionButtonStyled
      variant={primary ? ActionButtonVariants.PRIMARY : ActionButtonVariants.OUTLINE}
      eventAttributes={{ Name: shouldGoToCart ? continueToCartText : children }}
      leftIcon={<Icon variant={iconVariant} />}
      onPress={handleOnPress}
      marginTop={marginTop}
      backgroundColor={backgroundColor}
      _text={_text}
    >
      {continueToCartText}
    </ActionButtonStyled>
  );
};

export const CTAButtons = ({
  numberOfItemsInCart,
  serviceMode,
  itemId,
  navigate,
}: ICTAButtonsProps) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <CTAButton
        primary
        defaultLinkTo={routes.storeLocator}
        iconVariant="cart"
        isMatchingServiceMode={isPickup(serviceMode)}
        numberOfItemsInCart={numberOfItemsInCart}
        navigate={navigate}
        eventName={CustomEventNames.HERO_PRIMARY_CTA_CLICK}
        itemId={itemId}
      >
        {formatMessage({ id: 'orderPickup' })}
      </CTAButton>
      <CTAButton
        defaultLinkTo={routes.address}
        iconVariant="delivery"
        isMatchingServiceMode={isDelivery(serviceMode)}
        numberOfItemsInCart={numberOfItemsInCart}
        navigate={navigate}
        marginTop="$4"
        eventName={CustomEventNames.HERO_COMPLEMENTARY_CTA_CLICK}
        itemId={itemId}
        _text={{ color: Styles.color.red }}
      >
        {formatMessage({ id: 'orderDelivery' })}
      </CTAButton>
    </>
  );
};
